import { computed, effect, inject } from "@angular/core";
import { FiscaliteVersement, ProjectionParams } from "@mra/hlp9002";
import { getState, patchState, signalStore, withComputed, withHooks, withMethods, withState } from "@ngrx/signals";
import { LocalStorageService, StateKey } from "../shared/services/local-storage.service";
import { VersementState } from "./state";

function createDefaultState(): VersementState {
  return {
    fiscaliteVersement: null,
    versementConfig: null,
    editedIban: ""
  };
}

export const versementStore = signalStore(
  { providedIn: "root" },

  withState(createDefaultState()),

  withComputed((state) => ({
    getState: computed(() => ({
      fiscaliteVersement: state.fiscaliteVersement(),
      versementConfig: state.versementConfig(),
      editedIban: state.editedIban()
    })),
    tauxTmi: computed(() => state.fiscaliteVersement()?.tauxTMI ?? 30)
  })),

  withMethods((store) => ({
    retrieveState(savedState: VersementState): void {
      patchState(store, () => savedState ?? createDefaultState());
    },

    unsetSimulation(): void {
      patchState(store, () => createDefaultState());
    },

    setFiscalite(fiscaliteVersement: FiscaliteVersement): void {
      patchState(store, () => ({ fiscaliteVersement }));
    },

    setVersementConfig(versementConfig: ProjectionParams): void {
      patchState(store, () => ({ versementConfig }));
    },

    setIBAN(editedIban: string): void {
      patchState(store, () => ({ editedIban }));
    }
  })),

  withHooks((store) => {
    const localStorageService = inject(LocalStorageService);

    return {
      onInit() {
        const state = localStorageService.getSavedState<VersementState>(StateKey.VERSEMENT);
        if (state) store.retrieveState(state);
        effect(() => {
          const state: VersementState = getState(store);
          localStorageService.saveState(StateKey.VERSEMENT, state);
        });
      }
    };
  })
);
